import { render, staticRenderFns } from "./genManagerCert.vue?vue&type=template&id=e4d4c984&scoped=true&"
import script from "./genManagerCert.vue?vue&type=script&lang=js&"
export * from "./genManagerCert.vue?vue&type=script&lang=js&"
import style0 from "./genManagerCert.vue?vue&type=style&index=0&id=e4d4c984&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4d4c984",
  null
  
)

export default component.exports